/// <amd-module name="Notifications/Common/Services/MailConfigurationService" />

import { Services, VssService, IVssService, IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution"

/**
 * Service for retrieving the mail configuration on the host.
 */
export interface IMailConfigurationService extends IVssService {

    /**
     * Returns 'true' if email is configured on the host, 'false' otherwise.
     */
    isEnabled(): boolean;
}

interface IMailConfigurationData {
    isEnabled: boolean;
}

class MailConfigurationService extends VssService implements IMailConfigurationService {

    public isEnabled(): boolean {

        const contributionService: IVssContributionService =
            this.pageContext.getService<IVssContributionService>("IVssContributionService");

        const mailSettings: IMailConfigurationData | undefined =
            contributionService.getData<IMailConfigurationData>("ms.vss-notifications-web.mail-configuration");

        if (mailSettings) {
            return mailSettings.isEnabled;
        }

        return false;
    }
}

Services.add("IMailConfigurationService", { serviceFactory: MailConfigurationService });
